'use strict';
angular
	.module('theme')
	.directive('productTracker', function ($timeout, ProductTrackerService) {
		return {
			restrict: 'A',
			scope: {
				productId: '@productTracker',
				last: '<',
				count: '<',
			},
			link: function ($scope, elem) {
				var product = {
					id: $scope.productId,
					position: $scope.count,
				};
				ProductTrackerService.addProduct(elem, product);

				if ($scope.last) {
					ProductTrackerService.init();
				}
			},
		};
	});
